export const teachers = [
  {
    id: 1,
    name: '정기훈',
    subject: '수능 국어 전문',
    experience: '15년 경력',
    description: '서울대 국어교육과 출신으로 수능 국어 만점자를 다수 배출한 베테랑 강사입니다. 체계적인 커리큘럼과 학생 맞춤형 지도로 정평이 나있습니다.',
    avatar: 'https://static.readdy.ai/image/214ff5c1b13b1a0264073f21c7776aa4/01c456ed11e4aca219b4d5ddc4e426ac.jpeg',
    fullDescription: '15년간 수능 국어를 전문으로 지도해온 정기훈 선생님은 학생 개개인의 수준과 목표에 맞춘 맞춤형 교육으로 수많은 수능 국어 만점자를 배출해왔습니다. 복잡한 비문학 지문도 명쾌하게 분석하는 능력과 학생들의 사고력을 키우는 독창적인 교수법으로 정평이 나있습니다.',
    education: [
      '서울대학교 국어교육과 학사',
      '서울대학교 국어교육과 석사',
      '한국교육과정평가원 수능 출제위원 연수 수료'
    ],
    career: [
      '현 국담 국어학원 대표 강사',
      '前 대치동 명문학원 수능국어 팀장',
      '前 EBS 수능특강 검토위원',
      '수능 국어 영역 교재 다수 집필'
    ],
    awards: [
      '2023 대한민국 교육대상 수상',
      '2022 학부모가 뽑은 명강사상',
      '2020 수능 국어 만점자 최다 배출 강사'
    ],
    courses: ['수능 국어 정규반', '수능 국어 파이널반'],
    philosophy: '국어는 단순 암기가 아닌 사고력의 확장입니다. 학생들이 스스로 생각하고 답을 찾아가는 과정을 통해 진정한 국어 실력을 키울 수 있도록 지도합니다.',
    stats: {
      students: 2500,
      perfectScores: 47,
      satisfaction: 98
    }
  },
  {
    id: 2,
    name: '이준호',
    subject: '논술 전문',
    experience: '12년 경력',
    description: '연세대 국문학과 박사 출신으로 대입 논술 전문가입니다. 명확한 논리 구조와 설득력 있는 글쓰기 지도에 탁월합니다.',
    avatar: 'https://public.readdy.ai/ai/img_res/ddbb99772a4fb316ecdd98b079053885.jpg',
    fullDescription: '연세대학교 국문학과 박사 출신의 이준호 선생님은 대입 논술 분야의 최고 전문가입니다. 12년간 축적된 노하우로 학생들의 논리적 사고력과 글쓰기 능력을 체계적으로 향상시키며, 매년 수많은 논술 합격생을 배출하고 있습니다.',
    education: [
      '연세대학교 국어국문학과 학사',
      '연세대학교 국어국문학과 석사',
      '연세대학교 국어국문학과 박사'
    ],
    career: [
      '현 국담 국어학원 논술 수석 강사',
      '前 연세대학교 글쓰기센터 강사',
      '前 대치동 논술전문학원 원장',
      '대입 논술 가이드북 저자'
    ],
    awards: [
      '2023 논술 합격률 1위 강사',
      '2021 베스트 논술 강사상',
      '2019 교육부 장관 표창'
    ],
    courses: ['대입 논술반'],
    philosophy: '좋은 글은 명확한 논리에서 시작됩니다. 학생들이 자신의 생각을 체계적으로 정리하고 설득력 있게 표현할 수 있도록 단계별로 지도합니다.',
    stats: {
      students: 1800,
      perfectScores: 156,
      satisfaction: 97
    }
  },
  {
    id: 3,
    name: '박지은',
    subject: '내신 국어 전문',
    experience: '10년 경력',
    description: '고려대 국어국문학과 출신으로 내신 1등급 학생을 다수 배출했습니다. 학교별 맞춤 지도와 세심한 관리가 강점입니다.',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Korean%20female%20teacher%20in%20her%20late%2020s%20with%20friendly%20smile%20wearing%20stylish%20modern%20attire%20in%20bright%20educational%20space%20with%20soft%20lighting%20and%20contemporary%20minimalist%20background&width=200&height=200&seq=teacher3&orientation=squarish',
    fullDescription: '고려대학교 국어국문학과 출신의 박지은 선생님은 내신 국어 전문가로서 학교별 출제 경향을 완벽하게 분석하여 맞춤형 지도를 제공합니다. 세심한 학생 관리와 체계적인 시험 대비로 매년 수많은 내신 1등급 학생을 배출하고 있습니다.',
    education: [
      '고려대학교 국어국문학과 학사',
      '고려대학교 교육대학원 국어교육 석사'
    ],
    career: [
      '현 국담 국어학원 내신 전담 강사',
      '前 강남 명문학원 내신국어 팀장',
      '학교별 내신 분석 자료집 제작',
      '내신 국어 완벽 대비 교재 집필'
    ],
    awards: [
      '2023 내신 1등급 배출 최다 강사',
      '2022 학생 만족도 1위',
      '2021 강남구 우수 강사상'
    ],
    courses: ['학교별 내신반 편성'],
    philosophy: '내신은 꼼꼼함이 생명입니다. 학교별 출제 경향을 철저히 분석하고, 학생 개개인에게 맞는 학습 전략을 제시하여 확실한 성적 향상을 이끌어냅니다.',
    stats: {
      students: 1500,
      perfectScores: 89,
      satisfaction: 99
    }
  }
];
